import { Operation } from 'rfc6902';
import applyPatch from './applyPatch';

/**
 * Applies the given JSONPatch using the given initial state.
 * The given object is not mutated but a new object version of the object is
 * returned instead. Ignores any errors if operations could not be applied,
 * and attempts to apply each of them even if some of them fails.
 * @param obj initial state of the object
 * @param patch JSONPatch to apply
 * @returns new object with the patch applied
 */
export default function applyPatchIgnoringErrors<T>(obj: T, patch: Operation[]): T {
  return patch.reduce((result, op) => {
    try {
      return applyPatch(result, [op]);
    } catch {
      // Ignore any error
      return result;
    }
  }, obj);
}
